<style>
    .top-nav .mat-expansion-panel-content {
        position: relative;
        bottom: 16px;
    }
</style>
<div class="dropdown row">
    <img src="../../../assets/images/unnamed.png" class="hamburger-icon" alt="" title="" />
    <h3 class="cate">DANH MỤC SẢN PHẨM</h3>
    <div class="top-nav rsidebar span_1_of_left dropdown-content">
        <mat-accordion>
            <mat-expansion-panel *ngFor="let menu of menus">
                <mat-expansion-panel-header>
                    <a [routerLink]="['/introduce', menu.key]">{{menu.name}}</a>
                </mat-expansion-panel-header>
                <input #myname style="display: none;" type="text" value={{menu.key}}>
                <a *ngFor="let subMenu of subMenus" [routerLink]="['/list-menu-product']" [queryParams]="{ id1: menu.key, id2: subMenu.key }" (click)="reloadPage()">
                    <mat-action-row>{{subMenu.name}}</mat-action-row>
                </a>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>